export enum AttachmentType {
  image = 'image',
  youtube = 'youtube',
  model = 'model',
  thumbnail = 'thumbnail',
  zip = 'zip',
  other = 'other',
}

export enum AttachmentParentType {
  POST = 'post',
}

export enum IAttachmentCategory {
  postMedia = 'postMedia',
  postModel = 'postModel',
  postThumbnail = 'postThumbnail',
  postZip = 'postZip',
}

export type IAttachment = {
  _id: string;
  parentId: string;
  parentType: AttachmentParentType;
  fileName: string;
  user: string;
  resourcePath: string;
  url: string;
  fileSize: number;
  fileHash: string;
  resourceType: AttachmentType;
  category: IAttachmentCategory;
  downloadCount: number;
  createdAt: string;
  updatedAt: string;
};

export interface IGetPreSignedUploadUrlRequest {
  attachments: {
    parentId: string;
    parentType: AttachmentParentType;
    category: IAttachmentCategory;
    fileName: string;
    fileHash: string;
    fileSize: number;
    resourceType: AttachmentType;
  }[];
}

export interface IGetPreSignedUploadUrlResponse {
  signedUrl: null;
  attachmentId: null;
  duplicate: true;
  message: string;
  fileHash: string;
}
